import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { NbAuthService } from '@nebular/auth';
import { NbMenuItem, NbMenuService, NbSidebarService } from '@nebular/theme';
import { combineLatest, Observable } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';
import * as $ from 'jquery';
import { EntidadService } from 'src/app/services/entidad.service';
import { AuthService } from '../auth/auth.service';
import { Menu, MenuService } from './menu/menu.service';
import { Entidad } from '../auth/models/entidad.model';
import { Perfil } from '../services/perfil.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { DialogConfirmComponent } from '../auth/dialog/dialog-confirm/dialog-confirm.component';
import { MatDialog } from '@angular/material/dialog';
import { DashboardServiceService } from './dashboard-service.service';
import { SeguridadService, infoAuditoria } from '../services/seguridad.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  user?: string;
  itemsUsuario: NbMenuItem[] = [
    { title: 'Entidad' },
    { title: 'Perfil' },
    { title: 'Versión: V 0.2.257' },
    {
      title: 'Cerrar sesión',
      icon: 'log-out'
    },
  ];

  logoEntidad$: Observable<SafeUrl | null>;
  menus$: Observable<Menu[] | null> 
  collapse_side_bar_one:boolean = false;
  bo_recargarMenu:boolean=false;
  mostrarRuta = "";
  sloUrl = `/api/Saml/InitiateSingleLogout?returnUrl=${origin}/auth/logout`;
  time: any;
  auditoria?: infoAuditoria;
  nombreUsuario?: string;

  constructor(
    menuService: MenuService,
    sanitizer: DomSanitizer,
    private authService: AuthService,
    private nbAuthService: NbAuthService,
    private entidadService: EntidadService,
    private nbMenuService: NbMenuService,
    private nbSidebarService:NbSidebarService,
    private router: Router,
    public dialog: MatDialog,
    private dashBoardService: DashboardServiceService,
    private seguridadService: SeguridadService
  ) {
    
    this.menus$ = nbAuthService.onTokenChange().pipe(
      switchMap(() => menuService.getMenus())
    );
    this.logoEntidad$ = nbAuthService.onTokenChange().pipe(
      switchMap(() => this.entidadService.getLogoEntidad()),
      map(logo => URL.createObjectURL(logo)),
      map(url => sanitizer.bypassSecurityTrustUrl(url))
    );

    this.dashBoardService.searchUsuario().subscribe(res => {
      //console.log("User: ",res);
      let diasRestantes = res.iAlertaVencimientoContrasena;
      if(diasRestantes == null){
        diasRestantes = 10;
      }
      const fechaActual = new Date();
      const fechaExpiracion = new Date(res.dtFechaCambioPassword);
      const  milisegundosDiferencia = fechaExpiracion.getTime() - fechaActual.getTime();
      const diasDiferencia = milisegundosDiferencia / (1000 * 60 * 60 * 24);
      const diasDeDiferencia = Math.round(diasDiferencia);
      if(fechaExpiracion<fechaActual){
        //console.log("Entro fecha expirada");
        return this.router.navigate(['/dashboard/autogestioncontrasena']);
      }else{
        //console.log(`Días faltantes: ${diasDeDiferencia}`);
      if(diasDeDiferencia <= diasRestantes){
        return this.mensajeExpiracion(diasDeDiferencia);
      }
      }
      

    });
  }

  ngOnInit(): void {
    combineLatest([
      this.nbAuthService.getToken().pipe(
        map(token => token.getPayload()),
        filter<any>(Boolean)
      ),
      this.entidadService.getEntidades().pipe(
        filter(entidades => !!entidades),
        map(entidades => entidades || [])
      )
    ]).subscribe(([payload, entidades]) => {
      this.user = payload.name;

      const items = [];
      for (const entidad of entidades) {
        const item = this.map(entidad, payload.iIDEntidad);
        if (item.selected) {
          this.itemsUsuario[1].children = entidad.perfiles.map(x => this.map(x, payload.iIDPerfil));
        }
        items.push(item);
      }
      this.itemsUsuario[0].children = items;
    });

    this.nbMenuService.onItemClick().subscribe((event) => {
      if (event.tag == "MenuUsuario" && (!event.item.children || !event.item.children.length)) {
        const title = event.item.parent
          ? event.item.parent.title
          : event.item.title;
        this.onItemSelection(title, event.item.data);
      }
    });

  }

  

  map(item: Entidad | Perfil, id: number): NbMenuItem {
    const title = "title" in item ? item.title : item.tDescripcion;
    return {
      title: title,
      data: item,
      selected: item.id == id
    }
  }

  onItemSelection(event: string, data: any) {
    switch (event) {
      case 'Entidad': {
        const entidad = data as Entidad;
        const perfil = entidad.perfiles[0];
        this.time = entidad.timeExpire;
        this.updateToken(entidad.id, perfil.id, this.time);

        this.itemsUsuario[0].children?.forEach(y => y.selected = y.data.id === entidad.id);
        this.itemsUsuario[1].children = entidad.perfiles.map(x => this.map(x, perfil.id));
        break;
      }
      case 'Perfil': {
        const entidad = this.itemsUsuario[0].children?.find(x => x.selected)?.data as Entidad;
        const perfil = data as Perfil;
        this.updateToken(entidad.id, perfil.id, this.time);

        this.itemsUsuario[1].children?.forEach(y => y.selected = y.data.id === perfil.id);
        break;
      }
      case 'Cerrar sesión': {
        this.auditoria = {
          tFormulario : '~/auth/logout',
          tDescripcion: "El usuario "+ this.user +" ha cerrado sesión."
        };
        this.seguridadService.setAuditoria(this.auditoria).subscribe();
        localStorage.clear();
        //window.location.href = environment.sloUrl;
        this.nbAuthService.logout('email').subscribe( res => {
          res.isSuccess() && this.router.navigate(['../auth'])
        })
        window.location.href = this.sloUrl;
        break;
      }
    }
  }

  fnCollapse(sidebar: any) {
    $('#sidebar').css("z-index", 1 );
      if (sidebar == 'sidebar') {
        $('#sidebar').toggleClass('active');
        this.collapse_side_bar_one = $('#sidebar').hasClass('active');
        if (this.collapse_side_bar_one) {
          this.nbSidebarService.compact();
          $('.przss-content-child-menu').css('display', 'none');
 
        }else{
          this.nbSidebarService.expand();
        }
      }
      this.bo_recargarMenu=false;
  }

  Expand(){
    this.nbSidebarService.expand();
    this.bo_recargarMenu=false;
  }
  updateToken(iIDEntidad: number, iIDPerfil: number, timeExpire: number) {
    this.bo_recargarMenu=false;
    this.nbAuthService.getToken().pipe(
      filter(token => {
        const payload = token.getPayload();
        return +payload.iIDEntidad != iIDEntidad || +payload.iIDPerfil != iIDPerfil;
      }),
      switchMap(() => this.authService.updateToken(iIDEntidad, iIDPerfil, timeExpire))
    ).subscribe(x=>{
      if(x){
        if(this.collapse_side_bar_one){
          this.collapse_side_bar_one = false;
        }else{
          this.collapse_side_bar_one = true;
        }
        this.bo_recargarMenu=true;
      }
    });
    
     let self=this;
    /* self.bo_recargarMenu=false;
    if(self.collapse_side_bar_one){
      self.collapse_side_bar_one = false;
    }else{
      self.collapse_side_bar_one = true;
    } */
    setTimeout(function(){ self.bo_recargarMenu=false;
      if(self.collapse_side_bar_one){
        self.collapse_side_bar_one = false;
      }else{
        self.collapse_side_bar_one = true;
      }
    },1100)
  }

  mensajeExpiracion(info: any){
    const message = "Su contraseña expirará en " + info + " días";
    const dialogRef = this.dialog.open(DialogConfirmComponent,{
      width: '300px',
      data: message
    });

    dialogRef.afterClosed().subscribe(res =>{
      //console.log(res);
    });
  }
}